export default {
  model: [
    {
      label: 'Status',
      field: 'status',
      type: 'text'
    },
    {
      label: 'Descrição',
      field: 'error',
      type: 'text'
    },
  ]
}
